<template>
  <div class="footer_wrap">
    <footer class="footer pc_container">
      <dl>
        <!-- <div class="download_wrap">
          <dt class="download">Download</dt>
          <div class="download-app-qrcode oss-image-wrapper download-app-qrcode" style="background: url('https://file-cdn.resark.cc/image/1d/95e19bc8d8426ecbbd6dab6bdf6550.png?image_process=resize,w_124,h_124/quality,Q_75/format,webp') center top / 100% no-repeat"></div>
        </div> -->
        <div class="about_wrap">
          <dt class="about">
            <a href="">{{ $t('_yj._gy') }}</a>
          </dt>
          <dd>
            <a href="mailto:reelshortbiz@reelshortbiz.com" rel="nofollow">{{ $t('_yj._lxwm') }}(reelshortbiz@reelshortbiz.com)</a>
          </dd>
          <dd>
            <router-link :to="{ name: 'privacyPolicy' }" rel="nofollow">{{ $t('_yj._yszc') }}</router-link>
          </dd>
          <dd>
            <router-link :to="{ name: 'userAgreement' }" rel="nofollow">{{ $t('_yj._yhxy') }}</router-link>
          </dd>
          <dd>
            <router-link :to="{ name: 'rule' }" rel="nofollow">{{ $t('_yj._rule') }}</router-link>
          </dd>
          <!-- <dd><a href="/about" class="" rel="nofollow">About Us</a></dd> -->
        </div>
        <!-- <div>
          <dt class="community">Community</dt>
          <dd class="facebook"><a target="_blank" rel="nofollow"> Facebook </a></dd>
          <dd class="instagram"><a target="_blank" rel="nofollow"> Instagram </a></dd>
          <dd class="youTube"><a target="_blank" rel="nofollow"> YouTube </a></dd>
          <dd class="tikTok"><a target="_blank" rel="nofollow"> TikTok </a></dd>
        </div> -->
        <div>
          <dt class="language">{{ $t('_b._qhyy') }}</dt>
          <div class="language_select">
            <span class="language_val">{{ current.text }}</span>
            <div class="sstqe1 lxbox">
              <ul class="language_ul">
                <!--[-->
                <li :class="{ active: current.lang == item.lang }" v-for="(item, i) in languages" :key="i" @click="onLanguage(item)">
                  <div class="langs-img" :class="'langs-' + item.lang"></div>
                  <div>{{ item.text }}</div>
                </li>
                <!--]-->
              </ul>
            </div>
          </div>
        </div>
      </dl>
      <div class="copyright">
        <p class="text">ReelShortBiz All Rights Reserved.</p>
        <!-- <p>
          <a rel="nofollow">Terms of Use</a> &amp;
          <a rel="nofollow">Privacy Policy</a>
        </p> -->
      </div>
    </footer>
  </div>
  <a href="#top">
    <img
      src="data:image/png;base64,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"
      class="backTop"
      style=""
    />
  </a>
</template>

<script>
import languages from '@/utils/languages'
import Const from '@/utils/const'
import { getCurrentInstance } from 'vue'
import { setLangauge } from '@/utils/vue-i18n'
export default {
  name: 'FooterVue',
  setup() {
    const { proxy } = getCurrentInstance()
    function change(language) {
      proxy.$i18n.locale = language.lang
      setLangauge(language)
      console.log('切换语言', language)
    }
    return { change }
  },
  data() {
    return {
      current: {},
      languages: languages
    }
  },
  created() {
    const lang = localStorage.getItem(Const.KEY_LANG)

    this.current = lang
      ? JSON.parse(lang)
      : {
          text: 'English',
          lang: 'en-us'
        }
  },
  methods: {
    onLanguage(item) {
      this.current = item
      localStorage.setItem(Const.KEY_LANG, JSON.stringify(item))
      this.change(this.current)
      location.reload()
    }
  }
}
</script>

<style scoped>
@import url('../../static/css/top.css');
@import url('../../static/lang/lang.css');
</style>
<style scoped>
.lxbox {
  display: none;
}
.language_select:hover .lxbox {
  display: block;
}
</style>
